<template>
  <b-dropdown no-caret right variant="transparent" class="reportButton" :disabled="isDisabled">
    <template v-slot:button-content>
      <v-icon scale="1" class="aok" :name="icon"></v-icon>
      <div><strong>{{title}}</strong></div>
    </template>

    <template v-for="item in items">
      <b-dropdown-item  v-if="item.route" :to="item.route" :key="item.extname">{{item.title}}</b-dropdown-item>
      <b-dropdown-item  v-else  @click="onReportClicked(item.extname)" :key="item.extname">{{item.title}}</b-dropdown-item>
    </template>

  </b-dropdown>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ReportsService from "../services/ReportsService";
import PageNavigator from "../services/PageNavigator";

export default {
  name: 'ReportButton',

  props: {
    icon: String,
    title: String,
    items: Array,
    disable: Boolean
  },

  computed: {
    ...mapState(['activeSurvey', 'absoluteDrillPath']),
    ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

    isDisabled() {
      return this.items.length===0 || this.disable
    }

  },

  methods: {
    onReportClicked(reportName) {
      ReportsService.createReportTask(this.authToken, this.realmName, this.studyName, reportName, this.completePath).then((response) => {
        this.$store.commit('addReport', response.data.uuid)
        PageNavigator.navigateToReportsPage(this.$router, this.studyName)
      })

    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

div.reportButton {
  margin-left: 1em;
  margin-right: 1em;
}

.reportButton button  {
  color: white;
  padding-top: 0;
  padding-bottom: 0;
}


</style>
